import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { popSignUp, SignUpElement, SignUpType } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { getLocationOrThrow } from "@faire/web--source/common/globals/getLocation";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { parseQueryParams } from "@faire/web--source/common/query-params/parseQueryParams";
import { Button } from "@faire/web--source/slate/Button";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import isObject from "lodash/isObject";
import * as React from "react";
import { useHistory } from "react-router-dom";
export var ErrorMessage = function(param) {
    var error = param.error, align = param.align, small = param.small;
    var _error_responseBody, _error_responseBody1;
    if (!error || !isObject(error)) {
        return null;
    }
    var serverError = error.httpStatusCode !== undefined && error.httpStatusCode >= 500;
    var badTokenError = error.httpStatusCode !== undefined && error.httpStatusCode === 400 && ((_error_responseBody = error.responseBody) === null || _error_responseBody === void 0 ? void 0 : _error_responseBody.field) === "resetPasswordToken";
    var queryParams = parseQueryParams(getLocationOrThrow().search);
    var isMobile = queryParams.get("native_env") === "true";
    if (serverError) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "1x"
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    role: "alert",
                    color: Core.text.critical,
                    align: align !== null && align !== void 0 ? align : "center",
                    "data-test-id": "signin-error-msg",
                    variant: small ? "labelSansRegular" : "paragraphSansRegular",
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "Q9mJ7R",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Something went wrong. Please try again or contact us."
                            }
                        ]
                    })
                })
            ]
        });
    } else if (badTokenError) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "1x"
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    role: "alert",
                    color: Core.text.critical,
                    align: align !== null && align !== void 0 ? align : "center",
                    "data-test-id": "signin-error-msg",
                    variant: small ? "labelSansRegular" : "paragraphSansRegular",
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "MNm3VI",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "This reset password link has expired or already been used."
                            }
                        ]
                    })
                }),
                !isMobile ? /*#__PURE__*/ _jsx(Button, {
                    variant: "tertiary",
                    onClick: function() {
                        return getLocationOrThrow().replace(getCurrentPath().replace({
                            signIn: "1"
                        }).toString());
                    },
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "Ap28Q0",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Login with your new password"
                            }
                        ]
                    })
                }) : null
            ]
        });
    }
    var _error_responseBody_message;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                height: "1x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                role: "alert",
                color: Core.text.critical,
                align: align !== null && align !== void 0 ? align : "center",
                "data-test-id": "signin-error-msg",
                variant: small ? "labelSansRegular" : "paragraphSansRegular",
                children: (_error_responseBody_message = (_error_responseBody1 = error.responseBody) === null || _error_responseBody1 === void 0 ? void 0 : _error_responseBody1.message) !== null && _error_responseBody_message !== void 0 ? _error_responseBody_message : error.message
            })
        ]
    });
};
export var ErrorNotValidEmail = function(param) {
    var error = param.error, email = param.email;
    var history = useHistory();
    if (error.httpStatusCode === 404 && email) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "1x"
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    role: "alert",
                    color: Core.text.critical,
                    align: "left",
                    "data-test-id": "signin-error-msg",
                    variant: "labelSansRegular",
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "9hoR0y",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "No account found for this email. "
                            },
                            {
                                type: 8,
                                value: "EmailLinkFormatting",
                                children: [
                                    {
                                        type: 0,
                                        value: "Sign up"
                                    }
                                ]
                            }
                        ],
                        values: {
                            EmailLinkFormatting: getCreateAccountLink(history, email)
                        }
                    })
                })
            ]
        });
    } else {
        return /*#__PURE__*/ _jsx(ErrorMessage, {
            error: error,
            align: "left",
            small: true
        });
    }
};
var getCreateAccountLink = function(history, signUpEmail) {
    return function getCreateAccountLink(chunks) {
        return /*#__PURE__*/ _jsx(Button, {
            tertiaryColor: "inherit",
            small: true,
            onClick: function() {
                popSignUp(history, SignUpType.GENERIC, function() {}, {
                    element: SignUpElement.MODAL,
                    sourceId: "signin_modal_email_view_create_account_link_new_UI"
                }, {
                    email: signUpEmail,
                    signIn: undefined
                });
            },
            variant: "tertiary",
            children: /*#__PURE__*/ _jsx(Typography, {
                variant: "labelSansRegular",
                children: chunks
            })
        });
    };
};
